import { jsx as _jsx } from "react/jsx-runtime";
import { LogOut, Settings, UserRound } from "lucide-react";
import { Icon } from "../icons.js";
import { Menu } from "./Menu.js";
/**
 * The account menu (design-spec §4 "Avatar menu"): a 34px `--accent-pale` circle at the right
 * of the top bar, opening a {@link Menu} below right with `Settings`, then `Sign out`. The
 * circle draws a person glyph in `--accent`, not initials, and the menu has no head naming the
 * owner or the org: no identity read exists (README "Later"). Open, the circle wears a ring,
 * `--avatar-ring`, set by the `[data-avatar][aria-expanded="true"]` rule in `interactions.css`.
 */
export function AvatarMenu({ onSettings, onSignOut }) {
    const icon = (glyph) => _jsx(Icon, { icon: glyph, size: 17, "aria-hidden": "true" });
    const items = [
        ...(onSettings ? [{ id: "settings", label: "Settings", icon: icon(Settings), onSelect: onSettings }] : []),
        { id: "sign-out", label: "Sign out", icon: icon(LogOut), onSelect: onSignOut },
    ];
    return (_jsx(Menu, { label: "Account", items: items, trigger: (props) => (_jsx("button", { ...props, type: "button", "data-avatar": "", "aria-label": "Account", style: {
                width: 34, height: 34, padding: 0, margin: 0, border: "none", cursor: "pointer",
                display: "grid", placeItems: "center", borderRadius: "var(--radius-round)",
                background: "var(--accent-pale)", color: "var(--accent)",
                boxShadow: "var(--avatar-ring, none)",
            }, children: _jsx(Icon, { icon: UserRound, size: 18, strokeWidth: 1.8, "aria-hidden": "true" }) })) }));
}
